/**
 * Детерминированный цвет по строке (для стабильных цветов серий на графиках:
 * одна и та же метка серии всегда получает один и тот же цвет).
 * Ни `formatCurrency`/`getColorFromString`-эквивалента не нашлось в
 * `cabinet/src/shared/utils`/`cabinet/src/partner/shared/utils` — заводим
 * новый хелпер (Task 15, BarChart).
 */
export function getColorFromString(
  value: string,
  options?: { alpha?: number }
): string {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = hash % 360;
  const alpha = options?.alpha ?? 1;
  return `hsla(${hue}, 65%, 50%, ${alpha})`;
}
